import React from 'react'
import "../../Styles/yellowcalf.css/Wallet_Sales_Report_Based.css";

function Wallet_Sales_Report_Based() {
  return (
     <div className="sales-report-based-container" style={{ paddingTop: "25px" }}>
      <div className="sales-report-based-header-section">
        <div className="sales-report-based-header-box">
          <h3 className="sales-report-based-header-title">Wallet Sales Report Based on Operator</h3>

          <div className="sales-report-based-export-section">
            <button className="sales-report-based-export-button">
              Export <i className="fa fa-angle-down"></i>
            </button>

            <ul className="sales-report-based-export-list">
              <li><a href="#">Save as PDF</a></li>
              <li><a href="#">Save as PNG</a></li>
              <li><a href="#">Save as CSV</a></li>
              <li><a href="#">Save as TXT</a></li>
              <li><a href="#">Save as XML</a></li>
              <li><a href="#">Save as SQL</a></li>
              <li><a href="#">Save as JSON</a></li>
              <li><a href="#">Export to Excel</a></li>
              <li><a href="#">Export to Word</a></li>
              <li><a href="#">Export to PowerPoint</a></li>
            </ul>
          </div>
        </div>
      </div>

      <div className="sales-report-based-filter-section">
        <div className="sales-report-based-filter-row">
          <div className="sales-report-based-filter-item">
            <select id="student_id" className="sales-report-based-select">
              <option value="">Select Operator</option>
              <option value="189">ssds - hjh45</option>
              <option value="207">hebu - 78787878</option>
              <option value="211">siva - 34567889</option>
              <option value="186">Kaleem - 456</option>
              <option value="222">testing - 34567889</option>
              <option value="101">Mahesh - 546452367</option>
              <option value="224">ritu - 607046</option>
            </select>
          </div>

          <div className="sales-report-based-filter-item">
            <input
              type="date"
              id="startdate"
              className="sales-report-based-date-input"
              placeholder="Start Date"
            />
          </div>

          <div className="sales-report-based-filter-item">
            <input
              type="date"
              id="enddate"
              className="sales-report-based-date-input"
              placeholder="End Date"
            />
          </div>
          
          <div className="sales-report-based-filter-item">
            <button type="submit" className="sales-report-based-btn sales-report-based-btn-search">
              Search
            </button>
            <button type="reset" className="sales-report-based-btn sales-report-based-btn-clear">
              Clear
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Wallet_Sales_Report_Based
